import { render, staticRenderFns } from "./AddAccountant.vue?vue&type=template&id=1d6518e0&scoped=true"
import script from "./AddAccountant.vue?vue&type=script&lang=js"
export * from "./AddAccountant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6518e0",
  null
  
)

export default component.exports